var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProductsActiveIc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8382 20V11.9631L5 7.89932V15.0118C5 15.3094 5.07015 15.5827 5.21044 15.8317C5.35074 16.0805 5.54647 16.2793 5.79765 16.428L11.8382 20ZM13.1618 20L19.2024 16.428C19.4535 16.2793 19.6493 16.0805 19.7896 15.8317C19.9299 15.5827 20 15.3094 20 15.0118V7.89932L13.1618 11.9631V20ZM16.5332 8.39292L19.2804 6.75861L13.2974 3.22334C13.0464 3.07445 12.7806 3 12.5 3C12.2194 3 11.9536 3.07445 11.7026 3.22334L9.76471 4.36586L16.5332 8.39292ZM12.5 10.7911L15.2099 9.18831L8.43787 5.15581L5.71449 6.76382L12.5 10.7911Z",
    fill: "#3469E7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductsActiveIc);
export default __webpack_public_path__ + "static/media/products__active_ic.ac6fab1425c5f21dfc819d34609ce7f0.svg";
export { ForwardRef as ReactComponent };